import React, { StrictMode } from "react";
import { WrapPageElementBrowserArgs } from "gatsby";
import { createGlobalStyle } from "styled-components";
import { Banners, SummaryHeader, CheckoutHeader } from "layouts";
import { Provider } from "react-redux";
import { storeConfig } from "state/store";

const GlobalStyle = createGlobalStyle`
* {
    box-sizing: border-box;
    margin: 0;
}
body {
    overflow: hidden auto;
    background-color: #7f5a83;
    background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);
}
html {
    font-family: Poppins, -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Helvetica Neue, sans-serif;
}
`;

export const wrapRootElement: React.FC<WrapPageElementBrowserArgs> = ({
  element,
}) => (
  <StrictMode>
    <GlobalStyle />
    <Banners />
    <SummaryHeader />
    <CheckoutHeader />
    <Provider store={storeConfig().store}>{element}</Provider>
  </StrictMode>
);
